"use client";

import { c as _c } from "react/compiler-runtime";
import { PopularSearchesList } from "./PopularSearchesList";
import { TrendingProductsList } from "./TrendingProductsList";
export function SearchEmptyState() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-testid="search-empty-state"><PopularSearchesList /><TrendingProductsList /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}